import { makeObservable, observable, computed, action, runInAction } from 'mobx';
import SessionData from './SessionData.js';
import ApiService from '../Api/ApiService.js';
import ApiConfiguration from '../Api/ApiConfiguration.js';
import LoggerFactory from '../../Util/Logger/LoggerFactory.js';
import SessionPersistence from '../Persistence/SessionPersistence.js';
import defaultConfig from '../Config/defaultConfig.js';
import { removeTrailingSlashes } from '../../Util/url.js';
import SessionStoragePersistence from '../Persistence/SessionStoragePersistence.js';
import v4 from '../../../../../node_modules/.pnpm/uuid@9.0.0/node_modules/uuid/dist/esm-browser/v4.js';

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// ConfigService == everything "static", will not change after app has booted
// AppService    == everything else, which has to be "dynamic"
var AppService = /*#__PURE__*/function () {
  function AppService(authService, fetch, externalApiConfig) {
    _classCallCheck(this, AppService);
    this.authService = void 0;
    this.fetch = void 0;
    this.externalApiConfig = void 0;
    this.persistence = void 0;
    this.tracePersistence = void 0;
    this.logger = LoggerFactory.get('AppService');
    this.configuration = defaultConfig;
    this.currencyValue = null;
    this.language = null;
    this.tenantCode = null;
    this.affiliateNumber = null;
    this._apiHeaders = {};
    this._traceId = '';
    this.currencies = [];
    this.authService = authService;
    this.fetch = fetch;
    this.externalApiConfig = externalApiConfig;
    makeObservable(this, {
      configuration: observable,
      currencyValue: observable,
      language: observable,
      api: computed,
      currency: computed,
      lang: computed,
      tenant: computed,
      affiliate: computed,
      apiHeaders: computed,
      _apiHeaders: observable,
      setCurrency: action,
      setLang: action,
      setTenant: action,
      setAffiliate: action,
      setApiHeaders: action,
      config: computed,
      hydrate: action,
      persist: action,
      setConfigOnlyForStorybook: action,
      currencies: observable
    });
  }
  _createClass(AppService, [{
    key: "api",
    get: function get() {
      return new ApiService(new ApiConfiguration(_objectSpread({
        basePath: removeTrailingSlashes(this.configuration.apiUrl),
        fetchApi: this.fetch,
        apiKey: this.authService.state.token || undefined,
        headers: _objectSpread({
          'Accept-Language': this.lang,
          TraceId: this.traceId,
          Currency: this.currency,
          Tenant: this.tenant || '',
          Affiliate: this.affiliate || ''
        }, this._apiHeaders)
      }, this.externalApiConfig)));
    }
  }, {
    key: "currency",
    get: function get() {
      return this.currencyValue || this.configuration.currency || this.configuration.defaultCurrency;
    }
  }, {
    key: "lang",
    get: function get() {
      return this.language || this.configuration.defaultLanguage;
    }
  }, {
    key: "setCurrency",
    value: function setCurrency(c) {
      this.logger.log("set currency: ".concat(c));
      this.currencyValue = c;
      return this.persist();
    }
  }, {
    key: "setTenant",
    value: function setTenant(c) {
      this.logger.log("set tenant: ".concat(c));
      this.tenantCode = c;
      return this.persist();
    }
  }, {
    key: "tenant",
    get: function get() {
      return this.tenantCode;
    }
  }, {
    key: "setAffiliate",
    value: function setAffiliate(a) {
      this.logger.log("set affiliateNumber: ".concat(a));
      this.affiliateNumber = a;
      return this.persist();
    }
  }, {
    key: "affiliate",
    get: function get() {
      return this.affiliateNumber;
    }
  }, {
    key: "setTraceId",
    value: function setTraceId(traceId) {
      this._traceId = traceId;
    }
  }, {
    key: "traceId",
    get: function get() {
      return this._traceId;
    }
  }, {
    key: "setApiHeaders",
    value: function setApiHeaders(headers) {
      this._apiHeaders = headers;
    }
  }, {
    key: "apiHeaders",
    get: function get() {
      return this._apiHeaders;
    }
  }, {
    key: "setLang",
    value: function setLang(l) {
      this.language = l;
    }
  }, {
    key: "config",
    get: function get() {
      return this.configuration;
    }
  }, {
    key: "hydrate",
    value: function () {
      var _hydrate = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(config, isServerSide) {
        var _this = this;
        var hasData, hasTraceData, traceData, data;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.configuration = config;
              traceData = '';
              if (!isServerSide) {
                this.persistence = new SessionPersistence(SessionData);
                this.persistence.useKey(this.configuration.sessionKeyApp);
                hasData = this.persistence.exists();
                this.tracePersistence = new SessionStoragePersistence('');
                this.tracePersistence.useKey('ibetid');
                hasTraceData = this.tracePersistence.exists();
                traceData = hasTraceData ? this.tracePersistence.get() : v4();
                if (this.configuration.useTid) {
                  this.tracePersistence.set(traceData);
                }
              }
              if (!hasData) {
                _context.next = 9;
                break;
              }
              _context.next = 6;
              return this.persistence.get();
            case 6:
              _context.t0 = _context.sent;
              _context.next = 10;
              break;
            case 9:
              _context.t0 = new SessionData();
            case 10:
              data = _context.t0;
              runInAction(function () {
                _this.currencyValue = data.currency || _this.currency;
                _this.tenantCode = data.tenant || _this.configuration.tenant;
                _this.affiliateNumber = data.affiliate || _this.configuration.affiliate;
                _this._traceId = traceData;
              });
            case 12:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function hydrate(_x, _x2) {
        return _hydrate.apply(this, arguments);
      }
      return hydrate;
    }()
  }, {
    key: "persist",
    value: function () {
      var _persist = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this.persistence) {
                this.persistence.set({
                  currency: this.currency,
                  tenant: this.tenant,
                  affiliate: this.affiliate
                });
              }
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function persist() {
        return _persist.apply(this, arguments);
      }
      return persist;
    }()
  }, {
    key: "setConfigOnlyForStorybook",
    value: function setConfigOnlyForStorybook(config) {
      // config should not change in real app during runtime,
      // but in storybook we want to mock it per story
      this.configuration = config;
    }
  }, {
    key: "loadCurrencies",
    value: function () {
      var _loadCurrencies = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this2 = this;
        var currencies;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              currencies = [];
              _context3.prev = 1;
              _context3.next = 4;
              return this.api.getAllCurrencies();
            case 4:
              currencies = _context3.sent;
              _context3.next = 10;
              break;
            case 7:
              _context3.prev = 7;
              _context3.t0 = _context3["catch"](1);
              this.logger.warn(_context3.t0);
            case 10:
              runInAction(function () {
                _this2.currencies = currencies;
              });
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[1, 7]]);
      }));
      function loadCurrencies() {
        return _loadCurrencies.apply(this, arguments);
      }
      return loadCurrencies;
    }()
  }]);
  return AppService;
}();

export { AppService as default };
//# sourceMappingURL=AppService.js.map
